export const breadcrumbsItems = [
  {
    title: 'Мои организации',
    href: '/organization',
  },
  // {
  //   title: 'Создание организации',
  // },
]
